import LessonFormModal from "./LessonFormModal"

// Una lezione eliminata, rimessa dal registro delle eliminazioni: una
// lezione nuova, già compilata con quello che c'era, da rivedere e salvare
export function ReinsertLessonModal({ closeModal, lessonData }) {
	return <LessonFormModal mode="reinsert" closeModal={closeModal} lessonData={lessonData} />
}

export default ReinsertLessonModal
